import { render } from "./dom-footer.vue?vue&type=template&id=c4e4f386&scoped=true"
import script from "./dom-footer.vue?vue&type=script&lang=js"
export * from "./dom-footer.vue?vue&type=script&lang=js"

import "./dom-footer.vue?vue&type=style&index=0&id=c4e4f386&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c4e4f386"]])

export default __exports__